import React from "react";

export default function Section({ id, eyebrow, title, sub, children, className = "", center = false }) {
  return (
    <section id={id} className={`mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-14 sm:py-20 ${className}`}>
      {(eyebrow || title || sub) && (
        <div className={`mb-10 ${center ? "text-center mx-auto max-w-2xl" : "max-w-3xl"}`}>
          {eyebrow && <p className="text-xs font-medium uppercase tracking-[0.18em] text-[hsl(var(--accent))] mb-2">{eyebrow}</p>}
          {title && <h2 className="font-display text-3xl sm:text-4xl font-semibold tracking-tight">{title}</h2>}
          {sub && <p className="mt-3 text-base sm:text-lg text-muted-foreground">{sub}</p>}
        </div>
      )}
      {children}
    </section>
  );
}
